import React from 'react'
import PropTypes from 'prop-types'
import EmojiPicker from 'emoji-picker-react'
import { default as dayjs } from 'dayjs'

import { UpdateChat } from './UpdateChat'
import { useOnClickOutside } from '../../lib/OnClickOutside'
import { useCreateCall } from '../../lib/api/create'
import { useDeleteCall } from '../../lib/api/delete'
import { DeleteChat } from './deleteChat'
import chatBG from '../../assets/images/chat-bg-pattern.png'

export const Messages = ({
  isLocalEnvironment,
  authDetails,
  envData,
  activeChat,
  activeChatData,
  setActiveChat,
  setActiveChatData,
  contWidth,
  myChats,
}) => {
  const createCallMutation = useCreateCall()
  const deleteCallMutation = useDeleteCall()
  const [deleteConfirm, setDeleteConfirm] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(null)
  const [showChatDetails, setShowChatDetails] = React.useState(false)
  const [editChat, setEditChat] = React.useState(false)
  const userChatDetailsRef = React.useRef()
  useOnClickOutside(userChatDetailsRef, () => setShowChatDetails(false))
  const [openEmotics, setOpenEmotics] = React.useState(false)
  const onEmoTouch = (d) => {
    document.getElementById('chat-input').value =
      document.getElementById('chat-input').value + d.emoji
    setOpenEmotics(false)
  }
  const getNameInitials = (name) => {
    const fullName = name.split(' ')
    const intials = fullName[0]?.charAt(0) + (fullName[1] ? fullName[1]?.charAt(0) : '  ')
    return intials
  }
  const delConfirm = (id) => {
    setDeleteId(id)
    setDeleteConfirm(true)
  }
  const onDelete = async () => {
    await deleteCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/deleteData',
        apiEndpoint: 'chats',
        id: deleteId,
        messageTitle: 'Chats',
        message: 'Chat deleted successfully!',
        isDynamic: true,
      })
      .then(() => {
        setDeleteConfirm(false)
        setDeleteId(null)
        setActiveChat(null)
        setActiveChatData(null)
      })
  }
  const submitHandler = async (e) => {
    e.preventDefault()
    const data = new FormData(e.target)

    if (data.get('message') === null || data.get('message') === '') return
    const formData = {
      chatId: activeChat.chatId,
      chatMessageSenderId: authDetails.session.userId,
      chatMessageContent: JSON.stringify({
        message: data.get('message'),
        userName: authDetails.session.user.userFullName,
      }),
      isGroupChat: activeChatData.isGroupChat,
    }
    await createCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/addData',
        data: formData, //data,
        apiEndpoint: 'chatMessages',
        params: '',
        isDynamic: true,
        noConfirmation: true,
      })
      .then(() => {
        setActiveChatData({
          formData: [
            ...activeChatData.formData,
            {
              chatId: activeChat.chatId,
              chatMessageContent: JSON.stringify({
                message: data.get('message'),
                userName: authDetails.session.user.userFullName,
              }),
              chatMessageSenderId: authDetails.session.userId,
              chatMessageSender_isOrgUser: 0,
            },
          ],
        })
        document.getElementById('chat-input').value = ''
      })
  }
  React.useEffect(() => {
    if (activeChat !== null) {
      var messageBody = document.querySelector('#chat-conversation')
      messageBody.scrollTop = messageBody.scrollHeight - messageBody.clientHeight
    }
    const dataPush = []
    myChats.data?.formData?.length &&
      myChats.data?.formData?.map((d) => {
        dataPush.push({ data: d, new: 0 })
      })
    sessionStorage.setItem('myChats', JSON.stringify(dataPush))
  })

  return (
    <div
      className={`trtui-user-chat trtui-w-100 trtui-overflow-hidden ${contWidth > 728 || activeChat !== null ? 'trtui-user-chat-show' : ''}`}
      style={{ backgroundImage: `url(${chatBG})` }}
    >
      <div className="trtui-chat-content trtui-d-lg-flex">
        <div className="trtui-w-100 trtui-overflow-hidden trtui-position-relative">
          <div className="trtui-position-relative">
            {activeChat !== null ? (
              <>
                <div
                  className="trtui-position-relative"
                  id="users-chat"
                  style={{ display: 'block' }}
                >
                  <div className="trtui-p-3 trtui-user-chat-topbar">
                    <div className="trtui-row trtui-align-items-center">
                      <div className="trtui-col-sm-4 trtui-col-8">
                        <div className="trtui-d-flex trtui-align-items-center">
                          <div className="trtui-flex-shrink-0 trtui-d-block trtui-d-lg-none trtui-me-3">
                            <span
                              onClick={() => setActiveChat(null)}
                              className="trtui-user-chat-remove trtui-fs-18 trtui-p-1 trtui-cursor-pointer"
                            >
                              <i className="ri-arrow-left-s-line trtui-align-bottom" />
                            </span>
                          </div>
                          <div className="trtui-flex-grow-1 trtui-overflow-hidden">
                            <div className="trtui-d-flex trtui-align-items-center">
                              <div className="trtui-flex-shrink-0 trtui-chat-user-img trtui-online trtui-user-own-img trtui-align-self-center trtui-me-3 trtui-ms-0">
                                {/* <div className="trtui-avatar-title trtui-rounded-circle trtui-bg-primary trtui-text-white trtui-fs-5 trtui-p-1">
                                  {getNameInitials(activeChat.chatSubject)}
                                </div> */}
                                <div className="trtui-avatar-sm trtui-flex-shrink-0">
                                  <span className="trtui-avatar-title trtui-bg-primary trtui-rounded-circle trtui-fs-2">
                                    {getNameInitials(activeChat.chatSubject)}
                                  </span>
                                </div>
                                <span className="trtui-user-status" />
                              </div>
                              <div className="trtui-flex-grow-1 trtui-overflow-hidden">
                                <h5 className="trtui-text-truncate trtui-mb-0 trtui-fs-16">
                                  <span
                                    className="trtui-text-reset trtui-username"
                                    data-bs-toggle="offcanvas"
                                    aria-controls="userProfileCanvasExample"
                                  >
                                    {activeChat.chatSubject}
                                  </span>
                                </h5>
                                {/* <p className="trtui-text-truncate trtui-text-muted trtui-fs-14 mb-0 trtui-userStatus">
                                  <small>Online</small>
                                </p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="trtui-col-sm-8 trtui-col-4" style={{ textAlign: 'right' }}>
                        <div className="trtui-dropdown">
                          <button
                            className="trtui-btn trtui-btn-ghost-secondary trtui-btn-icon"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={() => setShowChatDetails(!showChatDetails)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-more-vertical icon-sm"
                            >
                              <circle cx={12} cy={12} r={1} />
                              <circle cx={12} cy={5} r={1} />
                              <circle cx={12} cy={19} r={1} />
                            </svg>
                          </button>
                          <div
                            className={`trtui-dropdown-menu trtui-dropdown-menu-end ${showChatDetails ? 'trtui-show' : ''}`}
                            style={{ right: '0px' }}
                            ref={userChatDetailsRef}
                          >
                            <span className="trtui-dropdown-item" onClick={() => setEditChat(true)}>
                              <i className="las la-users trtui-text-muted trtui-me-2" /> Edit Group
                            </span>
                            <a className="trtui-dropdown-item" href="#">
                              <i className="ri-inbox-archive-line trtui-align-bottom trtui-text-muted trtui-me-2" />{' '}
                              Archive
                            </a>
                            <a className="trtui-dropdown-item" href="#">
                              <i className="ri-mic-off-line trtui-align-bottom trtui-text-muted trtui-me-2" />{' '}
                              Muted
                            </a>
                            <span
                              className="trtui-dropdown-item"
                              onClick={() => delConfirm(activeChat.chatId)}
                            >
                              <i className="ri-delete-bin-5-line trtui-align-bottom trtui-text-muted trtui-me-2" />{' '}
                              Delete
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="trtui-chat-conversation trtui-p-3 trtui-p-lg-4 cScrollBar"
                    id="chat-conversation"
                    data-simplebar="init"
                    style={{ maxHeight: '100vh' }}
                  >
                    <div id="elmLoader" />
                    <ul
                      className="trtui-list-unstyled trtui-chat-conversation-list"
                      id="users-conversation"
                    >
                      {activeChatData !== null &&
                        activeChatData.formData?.length > 0 &&
                        activeChatData.formData
                          .sort((a, b) => new Date(a.createdDateTime) - new Date(b.createdDateTime))
                          .map((msg, msgInd) => (
                            <li
                              key={msgInd}
                              className={`trtui-chat-list ${msg.chatMessageSenderId === authDetails.session.userId ? 'trtui-right' : 'trtui-left'}`}
                              id={1}
                            >
                              {' '}
                              <div className="trtui-conversation-list">
                                {msg.chatMessageSenderId !== authDetails.session.userId && (
                                  <div className="trtui-chat-avatar">
                                    <div className="trtui-avatar-title trtui-rounded-circle trtui-bg-primary trtui-text-white trtui-fs-10 trtui-p-1">
                                      {getNameInitials(
                                        JSON.parse(msg.chatMessageContent).userName || '',
                                      )}
                                    </div>
                                  </div>
                                )}
                                <div className="trtui-user-chat-content">
                                  <div className="trtui-ctext-wrap">
                                    <div
                                      className="trtui-ctext-wrap-content"
                                      style={{ padding: '8px 8px 8px 8px' }}
                                    >
                                      <h6
                                        className="trtui-text-muted"
                                        style={{ fontSize: '0.65rem' }}
                                      >
                                        {msg.chatMessageSenderId === authDetails.session.userId
                                          ? 'You'
                                          : JSON.parse(msg.chatMessageContent).userName}
                                      </h6>
                                      <p
                                        className="trtui-mb-0 trtui-ctext-content"
                                        style={{ fontSize: '1rem' }}
                                      >
                                        {JSON.parse(msg.chatMessageContent).message}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="trtui-conversation-name">
                                    <small className="trtui-text-muted trtui-time">
                                      {dayjs(msg.createdDateTime).format('MMM D, YYYY h:mm A')}
                                    </small>
                                  </div>
                                </div>{' '}
                              </div>{' '}
                            </li>
                          ))}
                    </ul>
                  </div>
                </div>
                <div
                  className="trtui-position-relative"
                  id="channel-chat"
                  style={{ display: 'none' }}
                >
                  <div className="trtui-p-3 trtui-user-chat-topbar">
                    <div className="trtui-row trtui-align-items-center">
                      <div className="trtui-col-sm-4 trtui-col-8">
                        <div className="trtui-d-flex trtui-align-items-center">
                          <div className="trtui-flex-shrink-0 trtui-d-block trtui-d-lg-none trtui-me-3">
                            <a
                              href="javascript: void(0);"
                              className="trtui-user-chat-remove trtui-fs-18 trtui-p-1"
                            >
                              <i className="ri-arrow-left-s-line trtui-align-bottom" />
                            </a>
                          </div>
                          <div className="trtui-flex-grow-1 trtui-overflow-hidden">
                            <div className="trtui-d-flex trtui-align-items-center">
                              <div className="trtui-flex-shrink-0 trtui-chat-user-img trtui-online trtui-user-own-img trtui-align-self-center trtui-me-3 trtui-ms-0">
                                <img
                                  src="assets/images/users/avatar-2.jpg"
                                  className="trtui-rounded-circle trtui-avatar-xs"
                                  alt
                                />
                              </div>
                              <div className="trtui-flex-grow-1 trtui-overflow-hidden">
                                <h5 className="trtui-text-truncate trtui-mb-0 trtui-fs-16">
                                  <a
                                    className="trtui-text-reset trtui-username"
                                    data-bs-toggle="offcanvas"
                                    href="#userProfileCanvasExample"
                                    aria-controls="userProfileCanvasExample"
                                  >
                                    Lisa Parker
                                  </a>
                                </h5>
                                <p className="trtui-text-truncate trtui-text-muted trtui-fs-14 trtui-mb-0 trtui-userStatus">
                                  <small>24 Members</small>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="trtui-col-sm-8 trtui-col-4">
                        <ul className="trtui-list-inline trtui-user-chat-nav trtui-text-end mb-0">
                          <li className="trtui-list-inline-item trtui-m-0">
                            <div className="trtui-dropdown">
                              <button
                                className="trtui-btn trtui-btn-ghost-secondary trtui-btn-icon"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-search trtui-icon-sm"
                                >
                                  <circle cx={11} cy={11} r={8} />
                                  <line x1={21} y1={21} x2="16.65" y2="16.65" />
                                </svg>
                              </button>
                              <div className="trtui-dropdown-menu trtui-p-0 trtui-dropdown-menu-end trtui-dropdown-menu-lg">
                                <div className="p-2">
                                  <div className="trtui-search-box">
                                    <input
                                      type="text"
                                      className="trtui-form-control trtui-bg-light trtui-border-light"
                                      placeholder="Search here..."
                                      id="searchMessage"
                                    />
                                    <i className="ri-search-2-line trtui-search-icon" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="trtui-list-inline-item trtui-d-none trtui-d-lg-inline-block trtui-m-0">
                            <button
                              type="button"
                              className="trtui-btn trtui-btn-ghost-secondary trtui-btn-icon"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#userProfileCanvasExample"
                              aria-controls="userProfileCanvasExample"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-info icon-sm"
                              >
                                <circle cx={12} cy={12} r={10} />
                                <line x1={12} y1={16} x2={12} y2={12} />
                                <line x1={12} y1={8} x2="12.01" y2={8} />
                              </svg>
                            </button>
                          </li>
                          <li className="trtui-list-inline-item trtui-m-0">
                            <div className="trtui-dropdown">
                              <button
                                className="trtui-btn trtui-btn-ghost-secondary trtui-btn-icon"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-more-vertical icon-sm"
                                >
                                  <circle cx={12} cy={12} r={1} />
                                  <circle cx={12} cy={5} r={1} />
                                  <circle cx={12} cy={19} r={1} />
                                </svg>
                              </button>
                              <div className="trtui-dropdown-menu trtui-dropdown-menu-end">
                                <a
                                  className="trtui-dropdown-item trtui-d-block trtui-d-lg-none trtui-user-profile-show"
                                  href="#"
                                >
                                  <i className="ri-user-2-fill trtui-align-bottom trtui-text-muted trtui-me-2" />{' '}
                                  View Profile
                                </a>
                                <a className="trtui-dropdown-item" href="#">
                                  <i className="ri-inbox-archive-line trtui-align-bottom trtui-text-muted trtui-me-2" />{' '}
                                  Archive
                                </a>
                                <a className="trtui-dropdown-item" href="#">
                                  <i className="ri-mic-off-line trtui-align-bottom trtui-text-muted trtui-me-2" />{' '}
                                  Muted
                                </a>
                                <a className="trtui-dropdown-item" href="#">
                                  <i className="ri-delete-bin-5-line trtui-align-bottom trtui-text-muted trtui-me-2" />{' '}
                                  Delete
                                </a>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    className="trtui-chat-conversation trtui-p-3 trtui-p-lg-4"
                    id="chat-conversation"
                    data-simplebar="init"
                  >
                    <div className="simplebar-wrapper" style={{ margin: '-24px' }}>
                      <div className="simplebar-height-auto-observer-wrapper">
                        <div className="simplebar-height-auto-observer" />
                      </div>
                      <div className="simplebar-mask">
                        <div className="simplebar-offset" style={{ right: '0px', bottom: '0px' }}>
                          <div
                            className="simplebar-content-wrapper"
                            tabIndex={0}
                            role="region"
                            aria-label="scrollable content"
                            style={{ height: 'auto', overflow: 'hidden' }}
                          >
                            <div className="simplebar-content" style={{ padding: '24px' }}>
                              <ul
                                className="trtui-list-unstyled trtui-chat-conversation-list"
                                id="channel-conversation"
                              ></ul>
                              {/* end chat-conversation-list */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="simplebar-placeholder"
                        style={{ width: '0px', height: '0px' }}
                      />
                    </div>
                    <div
                      className="simplebar-track simplebar-horizontal"
                      style={{ visibility: 'hidden' }}
                    >
                      <div
                        className="simplebar-scrollbar"
                        style={{ width: '0px', display: 'none' }}
                      />
                    </div>
                    <div
                      className="simplebar-track simplebar-vertical"
                      style={{ visibility: 'hidden' }}
                    >
                      <div
                        className="simplebar-scrollbar"
                        style={{ height: '0px', display: 'none' }}
                      />
                    </div>
                  </div>
                </div>
                <div className="trtui-chat-input-section trtui-p-3 trtui-p-lg-4">
                  <form
                    id="chatinput-form"
                    onSubmit={(e) => submitHandler(e)}
                    encType="multipart/form-data"
                  >
                    <div className="trtui-row trtui-g-0 trtui-align-items-center">
                      <div className="trtui-col-auto">
                        <div className="trtui-chat-input-links trtui-me-2">
                          <div className="trtui-links-list-item">
                            {openEmotics && (
                              <div
                                id="removeItemModal"
                                className="trtui-modal trtui-fade trtui-zoomIn trtui-show"
                                tabIndex={-1}
                                aria-modal="true"
                                role="dialog"
                                style={{
                                  display: 'block',
                                  marginLeft: '12%',
                                }}
                              >
                                <div className="trtui-modal-dialog trtui-modal-dialog-centered">
                                  <div className="trtui-modal-content" style={{ width: '50%' }}>
                                    <EmojiPicker onEmojiClick={onEmoTouch} />
                                    <button
                                      className="trtui-btn trtui-btn-sm trtui-btn-icon trtui-btn-danger"
                                      onClick={() => setOpenEmotics(false)}
                                    >
                                      <i className="ri ri-close-line" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                            <button
                              type="button"
                              className="trtui-btn trtui-btn-link trtui-text-decoration-none trtui-emoji-btn"
                              id="emoji-btn"
                              onClick={() => setOpenEmotics(!openEmotics)}
                            >
                              <i className="bx bx-smile trtui-align-middle"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="trtui-col">
                        <div className="trtui-chat-input-feedback">Please Enter a Message</div>
                        <input
                          type="text"
                          name="message"
                          className="trtui-form-control trtui-chat-input trtui-bg-light border-light"
                          id="chat-input"
                          placeholder="Type your message..."
                          autoComplete="off"
                        />
                      </div>
                      <div className="trtui-col-auto">
                        <div className="trtui-chat-input-links trtui-ms-2">
                          <div className="trtui-links-list-item">
                            <button
                              type="submit"
                              className="trtui-btn trtui-btn-primary trtui-chat-send trtui-waves-effect trtui-waves-light"
                            >
                              <i className="ri-send-plane-2-fill trtui-align-bottom" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="trtui-replyCard">
                  <div className="trtui-card trtui-mb-0">
                    <div className="trtui-card-body trtui-py-3">
                      <div className="trtui-replymessage-block trtui-mb-0 trtui-d-flex trtui-align-items-start">
                        <div className="trtui-flex-grow-1">
                          <h5 className="trtui-conversation-name" />
                          <p className="trtui-mb-0" />
                        </div>
                        <div className="trtui-flex-shrink-0">
                          <button
                            type="button"
                            id="close_toggle"
                            disabled={createCallMutation.isLoading}
                            className="trtui-btn trtui-btn-sm trtui-btn-link trtui-mt-n2 trtui-me-n3 trtui-fs-18"
                          >
                            <i className="bx bx-x trtui-align-middle" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="trtui-position-relative" id="users-chat" style={{ display: 'block' }}>
                <div className="trtui-p-3 trtui-user-chat-topbar">
                  <div className="trtui-row trtui-align-items-center">
                    <div className="trtui-col-12">
                      <div className="trtui-d-flex trtui-align-items-center">
                        Select a conversation to chat
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {editChat && (
        <UpdateChat
          isLocalEnvironment={isLocalEnvironment}
          authDetails={authDetails}
          envData={envData}
          activeChat={activeChat}
          setNewMessageModal={setEditChat}
        />
      )}
      {deleteConfirm && (
        <DeleteChat
          onDelete={onDelete}
          deleteCallMutation={deleteCallMutation}
          setDeleteConfirm={setDeleteConfirm}
          setDeleteId={setDeleteId}
        />
      )}
    </div>
  )
}

Messages.propTypes = {
  activeChat: PropTypes.object,
  activeChatData: PropTypes.object,
  authDetails: PropTypes.object,
  envData: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
  setActiveChat: PropTypes.func,
  setActiveChatData: PropTypes.func,
  contWidth: PropTypes.number,
  myChats: PropTypes.object,
}
